import { render } from "./Pagination.vue?vue&type=template&id=3a3e272a"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"
script.render = render

export default script